import synopsis from '../components/synopsis';

const PagePerformance = ($) => {
	if ($("body").hasClass("performance-template-default")) {
		synopsis($);
	}
};

export default PagePerformance
